"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    root: _defineProperty({
      padding: theme.spacing(2, 0)
    }, theme.breakpoints.up('md'), {
      padding: theme.spacing(3)
    }),
    spacer: {
      marginBottom: theme.spacing(2),
      backgroundColor: '#ddd'
    }
  };
};

var _default = styles;
exports.default = _default;